// Client-side language preference persistence.
// The server root redirect reads the `locale` cookie; this module keeps
// it in sync with the language the user actually views (or picks), so `/`
// always lands on their chosen language.
(function () {
  const COOKIE_NAME = 'locale';
  const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

  function setCookie(locale) {
    document.cookie =
      COOKIE_NAME + '=' + encodeURIComponent(locale) +
      '; Path=/; SameSite=Lax; Max-Age=' + COOKIE_MAX_AGE;
  }

  function readCookie() {
    const match = document.cookie.match(new RegExp('(?:^|;)\\s*' + COOKIE_NAME + '=([^;]+)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function currentLocale() {
    return document.documentElement.lang || 'en';
  }

  // Sync the cookie to the locale being viewed (covers direct /ru/ visits).
  function sync() {
    const locale = currentLocale();
    const stored = readCookie();
    if (stored !== locale) {
      setCookie(locale);
      try { localStorage.setItem(COOKIE_NAME, locale); } catch (e) { /* ignore */ }
    }
  }

  // Persist the chosen locale when a language link is clicked.
  document.addEventListener('click', function (event) {
    const link = event.target.closest('.language-link');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    const match = href.match(/^\/([a-z]{2,3})\//);
    if (!match) return;
    const locale = match[1];
    setCookie(locale);
    try { localStorage.setItem(COOKIE_NAME, locale); } catch (e) { /* ignore */ }
  });

  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('page:load', sync);
})();
